import React, {createRef, useMemo, useState} from "react";
import Headerback from "../../../component/headerback";
import Question from "../../pretest/question";

const defalutschema = {
  id: 1,
  desc: '鉴赏篇',
  totalScore: 0,
  question: [
    {
      id: 1,
      desc: '以下关于《山居秋暝》的鉴赏，错误的一项是()',
      the_score: 0,
      options: [
        {
          label: '这首诗描绘了秋雨初晴后傍晚时分山村的旖旎风光和山居村民的淳朴风尚。',
          value: '这首诗描绘了秋雨初晴后傍晚时分山村的旖旎风光和山居村民的淳朴风尚。',
          score: 0,
          selected: false
        },
        {
          label: '这首诗中只有景物意象，没有人物意象。',
          value: '这首诗中只有景物意象，没有人物意象。',
          score: 1,
          selected: false
        },
        {
          label: '这首诗的作者是王维，王维是盛唐时期的山水诗人。',
          value: '这首诗的作者是王维，王维是盛唐时期的山水诗人。',
          score: 0,
          selected: false
        }
      ],
      selected: [

      ]
    }
  ]
}

window.localStorage.schema = JSON.stringify(defalutschema);

let a_schema;
try {
  a_schema = JSON.parse(window.localStorage.schema);
} catch { };

let refs = [];


export default function Partfour() {
    const [schema, setSchema] = useState(a_schema);
    let { question, desc, outScore } = schema;
    const [finish, setFinish] = useState(false);
    const [finishScore, setFinishScore] = useState(0);
    const [btnDisabled, setBtnDisabled] = useState(false);

    let totalScore;

    let newSchema = {
        id: 1,
        totalScore: 0,
        question: [],
      };

    const handleSave = () => {
        setBtnDisabled(true);

        setFinish(true);
        totalScore = 0;
        schema.question.forEach((item, index) => {
            const { getSchema } = refs[index].current;
            newSchema.question.push(getSchema());
            if (getSchema().the_score) {
                totalScore += getSchema().the_score;
            }

        });
        newSchema.totalScore = totalScore;
        window.localStorage.schema = JSON.stringify(newSchema);

        setFinishScore(newSchema.totalScore);
        alert(`你本次答对${newSchema.totalScore}道题!\n 1、解析：山水诗可以表现自然山水之美，同时可以表达诗人观赏时的心境感受。“不涉及诗人情感的抒发”是错误的。所以A项错误。`)
      }

      useMemo(() => {
        refs = question.map(item => createRef());
      }, [question])

    return(
        <div>
            <Headerback
                showPage={1}
            />
            <div className="page course-page">
                 <div className="page-con">
                     <div className="partonefour">
                         <div className="problem-inner">
                             <p className="desc">{desc}</p>
                             {
                                 schema.question.map((item, index) => {
                                  return (
                                    <div key={item.id} className="question">
                                      <p className="title">{item.id}、{item.desc}</p>
                                       <Question finish={finish} item={item} ref={refs[index]} yanz={[1,2,1]}></Question>
                                    </div>)
                                })
                             }

                         </div>
                     </div>
                     <button
                        className="miaov-btn miaov-btn-md problem-btn"
                        type="submit"
                        onClick={handleSave}
                        disabled={btnDisabled}
                        style={{
                            backgroundColor: btnDisabled ? 'gray' : '',
                            cursor: btnDisabled ? 'default' : 'pointer',
                            display: btnDisabled ? 'none' : 'inline-block'  
                        }}
                    >
                        提交
                    </button>
                 </div>
            </div>

        </div>
    )
}
